import { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useRouteError,
} from "react-router-dom";

import {
  AuthProvider,
  ProtectedRoute,
} from "./features/auth/AuthProvider";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { LoginPage } from "./features/auth/LoginPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { SignupPage } from "./features/auth/SignupPage";
import { VerifyEmailPage } from "./features/auth/VerifyEmailPage";
import { WorkspacePage } from "./features/workspace/WorkspacePage";

const LegacyLandingRedirect = () => {
  useEffect(() => {
    window.location.replace("/pet-product-instagram-hero.html");
  }, []);

  return <div className="route-loading">Opening Reelio…</div>;
};

const RouteError = () => {
  const error = useRouteError();

  return (
    <main className="route-error">
      <a className="brand-mark" href="/">
        reelio<span>.</span>
      </a>
      <h1>That page slipped out of frame.</h1>
      <p>
        {error instanceof Error
          ? error.message
          : "Return to signup and keep going."}
      </p>
      <a className="route-error__link" href="/auth/signup">
        Go to signup
      </a>
    </main>
  );
};

export const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    ),
    errorElement: <RouteError />,
    children: [
      {
        path: "/",
        element: <LegacyLandingRedirect />,
      },
      {
        path: "/auth/signup",
        element: <SignupPage />,
      },
      {
        path: "/auth/login",
        element: <LoginPage />,
      },
      {
        path: "/auth/signin",
        element: <Navigate to="/auth/login" replace />,
      },
      {
        path: "/auth/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/auth/reset-password",
        element: <ResetPasswordPage />,
      },
      {
        path: "/auth/verify-email",
        element: <VerifyEmailPage />,
      },
      {
        path: "/app",
        element: (
          <ProtectedRoute>
            <WorkspacePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "*",
        element: <Navigate to="/auth/signup" replace />,
      },
    ],
  },
]);
